// extracted by mini-css-extract-plugin
export var deliveryRow = "_qp-a";
export var fixedHeight = "_qp-4";
export var freightLogo = "_qp-9";
export var fullWidth = "_qp-3";
export var priceColumn = "_qp-5";
export var radioSelected = "_qp-7";
export var radioUnselected = "_qp-6";
export var selectedOption = "_qp-2";
export var selectedOptionContainer = "_qp-1";
export var selection = "_qp-0";
export var tallSkeletonText = "_qp-8";